import offeringResponse from '../data/offeringsResponse.json'
import { Box, Grid2 as Grid, Typography } from '@mui/material'
import { AppointmentProfile } from 'src/types'
import AppointmentSearchAutocomplete, {
    FilteredResults
} from 'src/pages/MUIBased/Appointments/components/AppointmentSearchAutocomplete'

const AppointmentSearchAutocompleteContent = () => {
    const getOptionLabel = (option: string | AppointmentProfile) => {
        if (typeof option === 'string') {
            return option
        }
        return option.label
    }

    const returnResults = (results: FilteredResults | undefined) => {
        console.log('RESULTS:', results)
    }

    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <Typography variant="h3" gutterBottom>
                    Appointment Search Autocomplete
                </Typography>
            </Grid>
            <Grid size={12}>
                <AppointmentSearchAutocomplete
                    name="appointmentSearch"
                    label="Search appointments"
                    options={
                        offeringResponse as unknown as AppointmentProfile[]
                    }
                    getOptionLabel={getOptionLabel}
                    returnResults={returnResults}
                />
                <Box>
                    Please note: changes to filtered items will be logged to the
                    console.
                </Box>
            </Grid>
        </Grid>
    )
}

export default {
    content: <AppointmentSearchAutocompleteContent />,
    slug: 'appointment-search-autocomplete',
    title: 'ASA'
}
